import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TransactionPrlObj, TransactionsSearchTypeObj} from '../../../../../generated/generated.model';
import {IdNameMxObj} from 'mx-core';

const TRANSACTIONS_REST_URL: string = '/rest/transactions/';

@Injectable({
    providedIn: 'root'
})
export class PrlTransactionsService {

    constructor(
        private httpClient: HttpClient
    ) {
    }

    public getDateRanges(): Observable<Array<IdNameMxObj>> {
        const url = TRANSACTIONS_REST_URL + 'date-ranges';
        return this.httpClient.get<Array<IdNameMxObj>>(url);
    };

    public getSearchTypes(): Observable<Array<TransactionsSearchTypeObj>> {
        const url = TRANSACTIONS_REST_URL + 'search-types';
        return this.httpClient.get<Array<TransactionsSearchTypeObj>>(url);
    };

    public getTransactionsData(): Observable<object> {
        return this.httpClient.get(TRANSACTIONS_REST_URL + 'data');
    };

    public getTransactionsFiltered(searchTypeId: number, dateRangeId: number, merchantId: number): Observable<Array<TransactionPrlObj>> {
        let url = TRANSACTIONS_REST_URL + 'type/' + searchTypeId + '/range/' + dateRangeId;

        if (merchantId) {
            url += '/merchant/' + merchantId;
        }

        return this.httpClient.get<Array<TransactionPrlObj>>(url);
    };

    public exportTransactions(searchTypeId: number, dateRangeId: number, langCode: string, merchantId: number): Observable<string> {
        let url = TRANSACTIONS_REST_URL + 'csv/type/' + searchTypeId + '/range/' + dateRangeId + '/lang/' + langCode;

        if (merchantId) {
            url += '/merchant/' + merchantId;
        }

        return this.httpClient.get(url, {responseType: 'text'});
    };

    public isShowBalance(searchTypeId: number): Observable<boolean> {
        return this.httpClient.get<boolean>(TRANSACTIONS_REST_URL + 'show-balance/type/' + searchTypeId);
    };
}

